<template>
  <div class="modal-backdrop" @click="$emit('click', $event)"></div>
</template>

<script>
export default {
  name: 'ModalBackdrop',
};
</script>

<style lang="scss" scoped>
@import '@scss/settings/_z-index.scss';

.modal-backdrop {
  background-color: rgba(0, 0, 0, 0.3);
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: map-get($zIndex, modalBackdrop);
}
</style>
